import {
  CCol,
  CRow
} from "@coreui/react";
import React from "react";
import {MEID_LABEL, PREVIOUS_MEID_LABEL} from "../../AppConstants";

const Item = ({item}) => {
  let {type, priceNoTax, description, deviceId, oldDeviceId} = item;

  return (
    <>
      <CRow>
        <CCol sm="2">
          {type === "service plan" ? <div className="service_plan"/> : <div className={type}/> }
        </CCol>
        <CCol sm="10">
          <div className="cartItemDescription">
            <span className="productType">{type} - </span>
            <span className="productInfo">{description}</span>
          </div>
          <div className="cartItem">${priceNoTax}</div>
          {deviceId && <div
            className="cartItem">{MEID_LABEL} - {deviceId}</div>}
          {oldDeviceId && <div
            className="cartItem">{PREVIOUS_MEID_LABEL} - {oldDeviceId}</div>}
        </CCol>
      </CRow>
    </>
  )
}

export default Item;
